const SPIN_THEME_DEFAULTS = {
  'gamification-spin': {
    pointerColor: 'A23B72',
    centerColor: 'FFFFFF',
    centerRadius: 35,
    outerRingColor: 'D9C6F3',
    outerRingWidth: 18,
    outerRingOffset: 0,
    outerRingVisible: true,
    dotsColor: '062F34',
    dotsSize: 4,
    dotsCount: 12,
    dotsOffset: 0,
    dotsVisible: true,
  },
  'gamification-spin-default': {
    pointerColor: 'A23B72',
    centerColor: 'FFFFFF',
    centerRadius: 35,
    outerRingColor: 'D9C6F3',
    outerRingWidth: 18,
    outerRingOffset: 0,
    outerRingVisible: true,
    dotsColor: '062F34',
    dotsSize: 4,
    dotsCount: 12,
    dotsOffset: 0,
    dotsVisible: true,
  },
  'gamification-spin-privy': {
    pointerColor: 'A23B72',
    centerColor: 'FFFFFF',
    centerRadius: 35,
    outerRingColor: 'D9C6F3',
    outerRingWidth: 18,
    outerRingOffset: 0,
    outerRingVisible: true,
    dotsColor: '062F34',
    dotsSize: 4,
    dotsCount: 12,
    dotsOffset: 0,
    dotsVisible: true,
    segmentColors: ['D4E02B', '0A5C63'],
  },
  'gamification-spin-shellshock': {
    pointerColor: 'A23B72',
    centerColor: 'FFFFFF',
    centerRadius: 35,
    outerRingColor: 'D9C6F3',
    outerRingWidth: 18,
    outerRingOffset: 0,
    outerRingVisible: true,
    dotsColor: '062F34',
    dotsSize: 4,
    dotsCount: 12,
    dotsOffset: 0,
    dotsVisible: true,
  },
};

const SCRATCH_THEME_DEFAULTS = {
  'gamification-scratch': {
    scratchCardSize: 320,
    scratchCardShape: 'rect',
    scratchOverlayColor: 'C0C0C0',
    scratchBgColor: 'E8E8E8',
    headerCurveHeight: 240,
    headerColor: 'FF6B6B',
  },
  'gamification-scratch-midnight': {
    scratchCardSize: 340,
    scratchCardShape: 'rect',
    scratchOverlayColor: '1E293B',
    scratchBgColor: '1E293B',
    headerCurveHeight: 220,
    headerColor: '4F46E5',
  },
};

const LOOT_BOX_THEME_DEFAULTS = {
  'gamification-loot-box': {
    boxColor: 'D4AF37',
    ribbonColor: 'E63946',
    rewardColor: 'E63946',
    boxCount: 3,
    boxSize: 120,
    boxPlacement: 'middle',
    boxAnimation: 'bounce',
    boxShadow: false,
    boxShadowColor: 'FFD700',
    boxStyle: 'style1',
  },
  'gamification-loot-box-midnight': {
    boxColor: '4F46E5',
    ribbonColor: 'F8FAFC',
    rewardColor: 'F8FAFC',
    boxCount: 3,
    boxSize: 120,
    boxPlacement: 'middle',
    boxAnimation: 'bounce',
    boxShadow: false,
    boxShadowColor: '818CF8',
    boxStyle: 'style1',
  },
};

function stripHash(color) {
  return color ? color.replace('#', '') : undefined;
}

export function getGamificationThemeDefaults(themeId) {
  return {
    spin: SPIN_THEME_DEFAULTS[themeId] || SPIN_THEME_DEFAULTS['gamification-spin'],
    scratch: SCRATCH_THEME_DEFAULTS[themeId] || SCRATCH_THEME_DEFAULTS['gamification-scratch'],
    lootBox: LOOT_BOX_THEME_DEFAULTS[themeId] || LOOT_BOX_THEME_DEFAULTS['gamification-loot-box'],
  };
}

export function resolveGamificationColor(value, fallback) {
  const normalized = stripHash(value);
  return normalized || fallback;
}
